import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import { theme } from 'lib/styles';

import {
	Container,
	Tip,
	TooltipIcon
} from './styles';

const Tooltip = props => {
	const TooltipTheme = { ...theme, ...{ main: props.danger ? theme.danger : theme.main } };

	return (
		<ThemeProvider theme={TooltipTheme}>
			<Container style={props.style || {}}>
				<Tip position={props.position}>{props.tooltip}</Tip>
				<TooltipIcon
					icon={props.icon}
					spin={props.spin ? 1 : 0}
					fill={props.fill}
					onClick={props.onClickHandler}
					tag="button"
				/>
			</Container>
		</ThemeProvider>
	)
};

Tooltip.propTypes = {
	danger: PropTypes.bool,
	fill: PropTypes.string,
	position: PropTypes.string,
	tooltip: PropTypes.string,
	icon: PropTypes.string,
	spin: PropTypes.bool,
	style: PropTypes.object,
	onClickHandler: PropTypes.func,
}

export default Tooltip;
